import { IHoanPhiTongHopRequest } from "../models/request/hoan-phi/HoanPhiTongHopRequest";
import { create_quyet_toan_request } from "../models/request/tonghop/create_quyet_toan_request";
import { sf_mucphaithu_create_quyet_toan } from "../models/request/tonghop/sf_mucphaithu_create_quyet_toan";
import { apiClient } from "./apiClient";

export const hoanPhiTongHopApi = {
    search: (data: IHoanPhiTongHopRequest) => apiClient.post(`sf_hoanphi_tonghop/search_hoanphi`, data),
    select_by_sf_hoanphi_tonghop: (data:number) => apiClient.post(`sf_hoanphi_tonghop_khoannop/select-by-sf_hoanphi_tonghop`, data),
    create_pdf_file: (sf_hoanphi_tonghop_ids:number[]) => apiClient.post(`sf_hoanphi_tonghop/create_pdf`, sf_hoanphi_tonghop_ids),
    send_pdf_file: (sf_hoanphi_tonghop_ids:number[]) => apiClient.post(`sf_hoanphi_tonghop/send_file`, sf_hoanphi_tonghop_ids),
    create_quyet_toan_multiple: (data: sf_mucphaithu_create_quyet_toan) => apiClient.post(`sf_hoanphi_tonghop/create_quyet_toan_multiple`, data),
    create_quyet_toan: (data: create_quyet_toan_request) => apiClient.post(`sf_hoanphi_tonghop/create_quyet_toan`, data),

}